
const  getOrCreateDeviceId = () =>  {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    deviceId = crypto.randomUUID(); // Génère un UUID v4
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
}

// 👉 Étape 2 : Hachage SHA-256 du deviceId
const hashDeviceId = async (deviceId) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(deviceId);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join(""); // Format hexadécimal
}

export const getHashedDeviceId = async () => {
  const deviceId = getOrCreateDeviceId();
  return await hashDeviceId(deviceId);
}